export function resolveCmsCarouselSlideLabel(
  template: string | null | undefined,
  index: number
): string | undefined {
  const normalizedTemplate = template?.trim();
  if (!normalizedTemplate) {
    return undefined;
  }

  return normalizedTemplate.replace('{index}', String(index + 1));
}
